import { render, staticRenderFns } from "./TemplatesOverviewView.vue?vue&type=template&id=5236c1bc&"
import script from "./TemplatesOverviewView.vue?vue&type=script&lang=ts&"
export * from "./TemplatesOverviewView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports